import ad from '@iconify/icons-fa-solid/ad';
import address_book from '@iconify/icons-fa-solid/address-book';
import address_card from '@iconify/icons-fa-solid/address-card';
import adjust from '@iconify/icons-fa-solid/adjust';
import air_freshener from '@iconify/icons-fa-solid/air-freshener';
import align_center from '@iconify/icons-fa-solid/align-center';
import align_justify from '@iconify/icons-fa-solid/align-justify';
import align_left from '@iconify/icons-fa-solid/align-left';
import align_right from '@iconify/icons-fa-solid/align-right';
import allergies from '@iconify/icons-fa-solid/allergies';
import ambulance from '@iconify/icons-fa-solid/ambulance';
import american_sign_language_interpreting from '@iconify/icons-fa-solid/american-sign-language-interpreting';
import anchor from '@iconify/icons-fa-solid/anchor';
import angle_double_down from '@iconify/icons-fa-solid/angle-double-down';
import angle_double_left from '@iconify/icons-fa-solid/angle-double-left';
import angle_double_right from '@iconify/icons-fa-solid/angle-double-right';
import angle_double_up from '@iconify/icons-fa-solid/angle-double-up';
import angle_down from '@iconify/icons-fa-solid/angle-down';
import angle_left from '@iconify/icons-fa-solid/angle-left';
import angle_right from '@iconify/icons-fa-solid/angle-right';
import angle_up from '@iconify/icons-fa-solid/angle-up';
import angry from '@iconify/icons-fa-solid/angry';
import ankh from '@iconify/icons-fa-solid/ankh';
import apple_alt from '@iconify/icons-fa-solid/apple-alt';
import archive from '@iconify/icons-fa-solid/archive';
import archway from '@iconify/icons-fa-solid/archway';
import arrow_alt_circle_down from '@iconify/icons-fa-solid/arrow-alt-circle-down';
import arrow_alt_circle_left from '@iconify/icons-fa-solid/arrow-alt-circle-left';
import arrow_alt_circle_right from '@iconify/icons-fa-solid/arrow-alt-circle-right';
import arrow_alt_circle_up from '@iconify/icons-fa-solid/arrow-alt-circle-up';
import arrow_circle_down from '@iconify/icons-fa-solid/arrow-circle-down';
import arrow_circle_left from '@iconify/icons-fa-solid/arrow-circle-left';
import arrow_circle_right from '@iconify/icons-fa-solid/arrow-circle-right';
import arrow_circle_up from '@iconify/icons-fa-solid/arrow-circle-up';
import arrow_down from '@iconify/icons-fa-solid/arrow-down';
import arrow_left from '@iconify/icons-fa-solid/arrow-left';
import arrow_right from '@iconify/icons-fa-solid/arrow-right';
import arrow_up from '@iconify/icons-fa-solid/arrow-up';
import arrows_alt from '@iconify/icons-fa-solid/arrows-alt';
import arrows_alt_h from '@iconify/icons-fa-solid/arrows-alt-h';
import arrows_alt_v from '@iconify/icons-fa-solid/arrows-alt-v';
import assistive_listening_systems from '@iconify/icons-fa-solid/assistive-listening-systems';
import asterisk from '@iconify/icons-fa-solid/asterisk';
import at from '@iconify/icons-fa-solid/at';
import atlas from '@iconify/icons-fa-solid/atlas';
import atom from '@iconify/icons-fa-solid/atom';
import audio_description from '@iconify/icons-fa-solid/audio-description';
import award from '@iconify/icons-fa-solid/award';
import baby from '@iconify/icons-fa-solid/baby';
import baby_carriage from '@iconify/icons-fa-solid/baby-carriage';
import backspace from '@iconify/icons-fa-solid/backspace';
import backward from '@iconify/icons-fa-solid/backward';
import bacon from '@iconify/icons-fa-solid/bacon';
import balance_scale from '@iconify/icons-fa-solid/balance-scale';
import balance_scale_left from '@iconify/icons-fa-solid/balance-scale-left';
import balance_scale_right from '@iconify/icons-fa-solid/balance-scale-right';
import ban from '@iconify/icons-fa-solid/ban';
import band_aid from '@iconify/icons-fa-solid/band-aid';
import barcode from '@iconify/icons-fa-solid/barcode';
import bars from '@iconify/icons-fa-solid/bars';
import baseball_ball from '@iconify/icons-fa-solid/baseball-ball';
import basketball_ball from '@iconify/icons-fa-solid/basketball-ball';
import bath from '@iconify/icons-fa-solid/bath';
import battery_empty from '@iconify/icons-fa-solid/battery-empty';
import battery_full from '@iconify/icons-fa-solid/battery-full';
import battery_half from '@iconify/icons-fa-solid/battery-half';
import battery_quarter from '@iconify/icons-fa-solid/battery-quarter';
import battery_three_quarters from '@iconify/icons-fa-solid/battery-three-quarters';
import bed from '@iconify/icons-fa-solid/bed';
import beer from '@iconify/icons-fa-solid/beer';
import bell from '@iconify/icons-fa-solid/bell';
import bell_slash from '@iconify/icons-fa-solid/bell-slash';
import bezier_curve from '@iconify/icons-fa-solid/bezier-curve';
import bible from '@iconify/icons-fa-solid/bible';
import bicycle from '@iconify/icons-fa-solid/bicycle';
import biking from '@iconify/icons-fa-solid/biking';
import binoculars from '@iconify/icons-fa-solid/binoculars';
import biohazard from '@iconify/icons-fa-solid/biohazard';
import birthday_cake from '@iconify/icons-fa-solid/birthday-cake';
import blender from '@iconify/icons-fa-solid/blender';
import blender_phone from '@iconify/icons-fa-solid/blender-phone';
import blind from '@iconify/icons-fa-solid/blind';
import blog from '@iconify/icons-fa-solid/blog';
import bold from '@iconify/icons-fa-solid/bold';
import bolt from '@iconify/icons-fa-solid/bolt';
import bomb from '@iconify/icons-fa-solid/bomb';
import bone from '@iconify/icons-fa-solid/bone';
import bong from '@iconify/icons-fa-solid/bong';
import book from '@iconify/icons-fa-solid/book';
import book_dead from '@iconify/icons-fa-solid/book-dead';
import book_medical from '@iconify/icons-fa-solid/book-medical';
import book_open from '@iconify/icons-fa-solid/book-open';
import book_reader from '@iconify/icons-fa-solid/book-reader';
import bookmark from '@iconify/icons-fa-solid/bookmark';
import border_all from '@iconify/icons-fa-solid/border-all';
import border_none from '@iconify/icons-fa-solid/border-none';
import border_style from '@iconify/icons-fa-solid/border-style';
import bowling_ball from '@iconify/icons-fa-solid/bowling-ball';
import box from '@iconify/icons-fa-solid/box';
import box_open from '@iconify/icons-fa-solid/box-open';
import boxes from '@iconify/icons-fa-solid/boxes';
import braille from '@iconify/icons-fa-solid/braille';
import brain from '@iconify/icons-fa-solid/brain';
import bread_slice from '@iconify/icons-fa-solid/bread-slice';
import briefcase from '@iconify/icons-fa-solid/briefcase';
import briefcase_medical from '@iconify/icons-fa-solid/briefcase-medical';
import broadcast_tower from '@iconify/icons-fa-solid/broadcast-tower';
import broom from '@iconify/icons-fa-solid/broom';
import brush from '@iconify/icons-fa-solid/brush';
import bug from '@iconify/icons-fa-solid/bug';
import building from '@iconify/icons-fa-solid/building';
import bullhorn from '@iconify/icons-fa-solid/bullhorn';
import bullseye from '@iconify/icons-fa-solid/bullseye';
import burn from '@iconify/icons-fa-solid/burn';
import bus from '@iconify/icons-fa-solid/bus';
import bus_alt from '@iconify/icons-fa-solid/bus-alt';
import business_time from '@iconify/icons-fa-solid/business-time';
import calculator from '@iconify/icons-fa-solid/calculator';
import calendar from '@iconify/icons-fa-solid/calendar';
import calendar_alt from '@iconify/icons-fa-solid/calendar-alt';
import calendar_check from '@iconify/icons-fa-solid/calendar-check';
import calendar_day from '@iconify/icons-fa-solid/calendar-day';
import calendar_minus from '@iconify/icons-fa-solid/calendar-minus';
import calendar_plus from '@iconify/icons-fa-solid/calendar-plus';
import calendar_times from '@iconify/icons-fa-solid/calendar-times';
import calendar_week from '@iconify/icons-fa-solid/calendar-week';
import camera from '@iconify/icons-fa-solid/camera';
import camera_retro from '@iconify/icons-fa-solid/camera-retro';
import campground from '@iconify/icons-fa-solid/campground';
import candy_cane from '@iconify/icons-fa-solid/candy-cane';
import cannabis from '@iconify/icons-fa-solid/cannabis';
import capsules from '@iconify/icons-fa-solid/capsules';
import car from '@iconify/icons-fa-solid/car';
import car_alt from '@iconify/icons-fa-solid/car-alt';
import car_battery from '@iconify/icons-fa-solid/car-battery';
import car_crash from '@iconify/icons-fa-solid/car-crash';
import car_side from '@iconify/icons-fa-solid/car-side';
import caret_down from '@iconify/icons-fa-solid/caret-down';
import caret_left from '@iconify/icons-fa-solid/caret-left';
import caret_right from '@iconify/icons-fa-solid/caret-right';
import caret_square_down from '@iconify/icons-fa-solid/caret-square-down';
import caret_square_left from '@iconify/icons-fa-solid/caret-square-left';
import caret_square_right from '@iconify/icons-fa-solid/caret-square-right';
import caret_square_up from '@iconify/icons-fa-solid/caret-square-up';
import caret_up from '@iconify/icons-fa-solid/caret-up';
import carrot from '@iconify/icons-fa-solid/carrot';
import cart_arrow_down from '@iconify/icons-fa-solid/cart-arrow-down';
import cart_plus from '@iconify/icons-fa-solid/cart-plus';
import cash_register from '@iconify/icons-fa-solid/cash-register';
import cat from '@iconify/icons-fa-solid/cat';
import certificate from '@iconify/icons-fa-solid/certificate';
import chair from '@iconify/icons-fa-solid/chair';
import chalkboard from '@iconify/icons-fa-solid/chalkboard';
import chalkboard_teacher from '@iconify/icons-fa-solid/chalkboard-teacher';
import charging_station from '@iconify/icons-fa-solid/charging-station';
import chart_area from '@iconify/icons-fa-solid/chart-area';
import chart_bar from '@iconify/icons-fa-solid/chart-bar';
import chart_line from '@iconify/icons-fa-solid/chart-line';
import chart_pie from '@iconify/icons-fa-solid/chart-pie';
import check from '@iconify/icons-fa-solid/check';
import check_circle from '@iconify/icons-fa-solid/check-circle';
import check_double from '@iconify/icons-fa-solid/check-double';
import check_square from '@iconify/icons-fa-solid/check-square';
import cheese from '@iconify/icons-fa-solid/cheese';
import chess from '@iconify/icons-fa-solid/chess';
import chess_bishop from '@iconify/icons-fa-solid/chess-bishop';
import chess_board from '@iconify/icons-fa-solid/chess-board';
import chess_king from '@iconify/icons-fa-solid/chess-king';
import chess_knight from '@iconify/icons-fa-solid/chess-knight';
import chess_pawn from '@iconify/icons-fa-solid/chess-pawn';
import chess_queen from '@iconify/icons-fa-solid/chess-queen';
import chess_rook from '@iconify/icons-fa-solid/chess-rook';
import chevron_circle_down from '@iconify/icons-fa-solid/chevron-circle-down';
import chevron_circle_left from '@iconify/icons-fa-solid/chevron-circle-left';
import chevron_circle_right from '@iconify/icons-fa-solid/chevron-circle-right';
import chevron_circle_up from '@iconify/icons-fa-solid/chevron-circle-up';
import chevron_down from '@iconify/icons-fa-solid/chevron-down';
import chevron_left from '@iconify/icons-fa-solid/chevron-left';
import chevron_right from '@iconify/icons-fa-solid/chevron-right';
import chevron_up from '@iconify/icons-fa-solid/chevron-up';
import child from '@iconify/icons-fa-solid/child';
import church from '@iconify/icons-fa-solid/church';
import circle from '@iconify/icons-fa-solid/circle';
import circle_notch from '@iconify/icons-fa-solid/circle-notch';
import city from '@iconify/icons-fa-solid/city';
import clinic_medical from '@iconify/icons-fa-solid/clinic-medical';
import clipboard from '@iconify/icons-fa-solid/clipboard';
import clipboard_check from '@iconify/icons-fa-solid/clipboard-check';
import clipboard_list from '@iconify/icons-fa-solid/clipboard-list';
import clock from '@iconify/icons-fa-solid/clock';
import clone from '@iconify/icons-fa-solid/clone';
import closed_captioning from '@iconify/icons-fa-solid/closed-captioning';
import cloud from '@iconify/icons-fa-solid/cloud';
import cloud_download_alt from '@iconify/icons-fa-solid/cloud-download-alt';
import cloud_meatball from '@iconify/icons-fa-solid/cloud-meatball';
import cloud_moon from '@iconify/icons-fa-solid/cloud-moon';
import cloud_moon_rain from '@iconify/icons-fa-solid/cloud-moon-rain';
import cloud_rain from '@iconify/icons-fa-solid/cloud-rain';
import cloud_showers_heavy from '@iconify/icons-fa-solid/cloud-showers-heavy';
import cloud_sun from '@iconify/icons-fa-solid/cloud-sun';
import cloud_sun_rain from '@iconify/icons-fa-solid/cloud-sun-rain';
import cloud_upload_alt from '@iconify/icons-fa-solid/cloud-upload-alt';
import cocktail from '@iconify/icons-fa-solid/cocktail';
import code from '@iconify/icons-fa-solid/code';
import code_branch from '@iconify/icons-fa-solid/code-branch';
import coffee from '@iconify/icons-fa-solid/coffee';
import cog from '@iconify/icons-fa-solid/cog';
import cogs from '@iconify/icons-fa-solid/cogs';
import coins from '@iconify/icons-fa-solid/coins';
import columns from '@iconify/icons-fa-solid/columns';
import comment from '@iconify/icons-fa-solid/comment';
import comment_alt from '@iconify/icons-fa-solid/comment-alt';
import comment_dollar from '@iconify/icons-fa-solid/comment-dollar';
import comment_dots from '@iconify/icons-fa-solid/comment-dots';
import comment_medical from '@iconify/icons-fa-solid/comment-medical';
import comment_slash from '@iconify/icons-fa-solid/comment-slash';
import comments from '@iconify/icons-fa-solid/comments';
import comments_dollar from '@iconify/icons-fa-solid/comments-dollar';
import compact_disc from '@iconify/icons-fa-solid/compact-disc';
import compass from '@iconify/icons-fa-solid/compass';
import compress from '@iconify/icons-fa-solid/compress';
import compress_arrows_alt from '@iconify/icons-fa-solid/compress-arrows-alt';
import concierge_bell from '@iconify/icons-fa-solid/concierge-bell';
import cookie from '@iconify/icons-fa-solid/cookie';
import cookie_bite from '@iconify/icons-fa-solid/cookie-bite';
import copy from '@iconify/icons-fa-solid/copy';
import copyright from '@iconify/icons-fa-solid/copyright';
import couch from '@iconify/icons-fa-solid/couch';
import credit_card from '@iconify/icons-fa-solid/credit-card';
import crop from '@iconify/icons-fa-solid/crop';
import crop_alt from '@iconify/icons-fa-solid/crop-alt';
import cross from '@iconify/icons-fa-solid/cross';
import crosshairs from '@iconify/icons-fa-solid/crosshairs';
import crow from '@iconify/icons-fa-solid/crow';
import crown from '@iconify/icons-fa-solid/crown';
import crutch from '@iconify/icons-fa-solid/crutch';
import cube from '@iconify/icons-fa-solid/cube';
import cubes from '@iconify/icons-fa-solid/cubes';
import cut from '@iconify/icons-fa-solid/cut';
import database from '@iconify/icons-fa-solid/database';
import deaf from '@iconify/icons-fa-solid/deaf';
import democrat from '@iconify/icons-fa-solid/democrat';
import desktop from '@iconify/icons-fa-solid/desktop';
import dharmachakra from '@iconify/icons-fa-solid/dharmachakra';
import diagnoses from '@iconify/icons-fa-solid/diagnoses';
import dice from '@iconify/icons-fa-solid/dice';
import dice_d__20 from '@iconify/icons-fa-solid/dice-d20';
import dice_d__6 from '@iconify/icons-fa-solid/dice-d6';
import dice_five from '@iconify/icons-fa-solid/dice-five';
import dice_four from '@iconify/icons-fa-solid/dice-four';
import dice_one from '@iconify/icons-fa-solid/dice-one';
import dice_six from '@iconify/icons-fa-solid/dice-six';
import dice_three from '@iconify/icons-fa-solid/dice-three';
import dice_two from '@iconify/icons-fa-solid/dice-two';
import digital_tachograph from '@iconify/icons-fa-solid/digital-tachograph';
import directions from '@iconify/icons-fa-solid/directions';
import divide from '@iconify/icons-fa-solid/divide';
import dizzy from '@iconify/icons-fa-solid/dizzy';
import dna from '@iconify/icons-fa-solid/dna';
import dog from '@iconify/icons-fa-solid/dog';
import dollar_sign from '@iconify/icons-fa-solid/dollar-sign';
import dolly from '@iconify/icons-fa-solid/dolly';
import dolly_flatbed from '@iconify/icons-fa-solid/dolly-flatbed';
import donate from '@iconify/icons-fa-solid/donate';
import door_closed from '@iconify/icons-fa-solid/door-closed';
import door_open from '@iconify/icons-fa-solid/door-open';
import dot_circle from '@iconify/icons-fa-solid/dot-circle';
import dove from '@iconify/icons-fa-solid/dove';
import download from '@iconify/icons-fa-solid/download';
import drafting_compass from '@iconify/icons-fa-solid/drafting-compass';
import dragon from '@iconify/icons-fa-solid/dragon';
import draw_polygon from '@iconify/icons-fa-solid/draw-polygon';
import drum from '@iconify/icons-fa-solid/drum';
import drum_steelpan from '@iconify/icons-fa-solid/drum-steelpan';
import drumstick_bite from '@iconify/icons-fa-solid/drumstick-bite';
import dumbbell from '@iconify/icons-fa-solid/dumbbell';
import dumpster from '@iconify/icons-fa-solid/dumpster';
import dumpster_fire from '@iconify/icons-fa-solid/dumpster-fire';
import dungeon from '@iconify/icons-fa-solid/dungeon';
import edit from '@iconify/icons-fa-solid/edit';
import egg from '@iconify/icons-fa-solid/egg';
import eject from '@iconify/icons-fa-solid/eject';
import ellipsis_h from '@iconify/icons-fa-solid/ellipsis-h';
import ellipsis_v from '@iconify/icons-fa-solid/ellipsis-v';
import envelope from '@iconify/icons-fa-solid/envelope';
import envelope_open from '@iconify/icons-fa-solid/envelope-open';
import envelope_open_text from '@iconify/icons-fa-solid/envelope-open-text';
import envelope_square from '@iconify/icons-fa-solid/envelope-square';
import equals from '@iconify/icons-fa-solid/equals';
import eraser from '@iconify/icons-fa-solid/eraser';
import ethernet from '@iconify/icons-fa-solid/ethernet';
import euro_sign from '@iconify/icons-fa-solid/euro-sign';
import exchange_alt from '@iconify/icons-fa-solid/exchange-alt';
import exclamation from '@iconify/icons-fa-solid/exclamation';
import exclamation_circle from '@iconify/icons-fa-solid/exclamation-circle';
import exclamation_triangle from '@iconify/icons-fa-solid/exclamation-triangle';
import expand from '@iconify/icons-fa-solid/expand';
import expand_arrows_alt from '@iconify/icons-fa-solid/expand-arrows-alt';
import external_link_alt from '@iconify/icons-fa-solid/external-link-alt';
import external_link_square_alt from '@iconify/icons-fa-solid/external-link-square-alt';
import eye from '@iconify/icons-fa-solid/eye';
import eye_dropper from '@iconify/icons-fa-solid/eye-dropper';
import eye_slash from '@iconify/icons-fa-solid/eye-slash';
import fan from '@iconify/icons-fa-solid/fan';
import fast_backward from '@iconify/icons-fa-solid/fast-backward';
import fast_forward from '@iconify/icons-fa-solid/fast-forward';
import fax from '@iconify/icons-fa-solid/fax';
import feather from '@iconify/icons-fa-solid/feather';
import feather_alt from '@iconify/icons-fa-solid/feather-alt';
import female from '@iconify/icons-fa-solid/female';
import fighter_jet from '@iconify/icons-fa-solid/fighter-jet';
import file from '@iconify/icons-fa-solid/file';
import file_alt from '@iconify/icons-fa-solid/file-alt';
import file_archive from '@iconify/icons-fa-solid/file-archive';
import file_audio from '@iconify/icons-fa-solid/file-audio';
import file_code from '@iconify/icons-fa-solid/file-code';
import file_contract from '@iconify/icons-fa-solid/file-contract';
import file_csv from '@iconify/icons-fa-solid/file-csv';
import file_download from '@iconify/icons-fa-solid/file-download';
import file_excel from '@iconify/icons-fa-solid/file-excel';
import file_export from '@iconify/icons-fa-solid/file-export';
import file_image from '@iconify/icons-fa-solid/file-image';
import file_import from '@iconify/icons-fa-solid/file-import';
import file_invoice from '@iconify/icons-fa-solid/file-invoice';
import file_invoice_dollar from '@iconify/icons-fa-solid/file-invoice-dollar';
import file_medical from '@iconify/icons-fa-solid/file-medical';
import file_medical_alt from '@iconify/icons-fa-solid/file-medical-alt';
import file_pdf from '@iconify/icons-fa-solid/file-pdf';
import file_powerpoint from '@iconify/icons-fa-solid/file-powerpoint';
import file_prescription from '@iconify/icons-fa-solid/file-prescription';
import file_signature from '@iconify/icons-fa-solid/file-signature';
import file_upload from '@iconify/icons-fa-solid/file-upload';
import file_video from '@iconify/icons-fa-solid/file-video';
import file_word from '@iconify/icons-fa-solid/file-word';
import fill from '@iconify/icons-fa-solid/fill';
import fill_drip from '@iconify/icons-fa-solid/fill-drip';
import film from '@iconify/icons-fa-solid/film';
import filter from '@iconify/icons-fa-solid/filter';
import fingerprint from '@iconify/icons-fa-solid/fingerprint';
import fire from '@iconify/icons-fa-solid/fire';
import fire_alt from '@iconify/icons-fa-solid/fire-alt';
import fire_extinguisher from '@iconify/icons-fa-solid/fire-extinguisher';
import first_aid from '@iconify/icons-fa-solid/first-aid';
import fish from '@iconify/icons-fa-solid/fish';
import fist_raised from '@iconify/icons-fa-solid/fist-raised';
import flag from '@iconify/icons-fa-solid/flag';
import flag_checkered from '@iconify/icons-fa-solid/flag-checkered';
import flag_usa from '@iconify/icons-fa-solid/flag-usa';
import flask from '@iconify/icons-fa-solid/flask';
import flushed from '@iconify/icons-fa-solid/flushed';
import folder from '@iconify/icons-fa-solid/folder';
import folder_minus from '@iconify/icons-fa-solid/folder-minus';
import folder_open from '@iconify/icons-fa-solid/folder-open';
import folder_plus from '@iconify/icons-fa-solid/folder-plus';
import font from '@iconify/icons-fa-solid/font';
import football_ball from '@iconify/icons-fa-solid/football-ball';
import forward from '@iconify/icons-fa-solid/forward';
import frog from '@iconify/icons-fa-solid/frog';
import frown from '@iconify/icons-fa-solid/frown';
import frown_open from '@iconify/icons-fa-solid/frown-open';
import funnel_dollar from '@iconify/icons-fa-solid/funnel-dollar';
import futbol from '@iconify/icons-fa-solid/futbol';
import gamepad from '@iconify/icons-fa-solid/gamepad';
import gas_pump from '@iconify/icons-fa-solid/gas-pump';
import gavel from '@iconify/icons-fa-solid/gavel';
import gem from '@iconify/icons-fa-solid/gem';
import genderless from '@iconify/icons-fa-solid/genderless';
import ghost from '@iconify/icons-fa-solid/ghost';
import gift from '@iconify/icons-fa-solid/gift';
import gifts from '@iconify/icons-fa-solid/gifts';
import glass_cheers from '@iconify/icons-fa-solid/glass-cheers';
import glass_martini from '@iconify/icons-fa-solid/glass-martini';
import glass_martini_alt from '@iconify/icons-fa-solid/glass-martini-alt';
import glass_whiskey from '@iconify/icons-fa-solid/glass-whiskey';
import glasses from '@iconify/icons-fa-solid/glasses';
import globe from '@iconify/icons-fa-solid/globe';
import globe_africa from '@iconify/icons-fa-solid/globe-africa';
import globe_americas from '@iconify/icons-fa-solid/globe-americas';
import globe_asia from '@iconify/icons-fa-solid/globe-asia';
import globe_europe from '@iconify/icons-fa-solid/globe-europe';
import golf_ball from '@iconify/icons-fa-solid/golf-ball';
import gopuram from '@iconify/icons-fa-solid/gopuram';
import graduation_cap from '@iconify/icons-fa-solid/graduation-cap';
import greater_than from '@iconify/icons-fa-solid/greater-than';
import greater_than_equal from '@iconify/icons-fa-solid/greater-than-equal';
import grimace from '@iconify/icons-fa-solid/grimace';
import grin from '@iconify/icons-fa-solid/grin';
import grin_alt from '@iconify/icons-fa-solid/grin-alt';
import grin_beam from '@iconify/icons-fa-solid/grin-beam';
import grin_beam_sweat from '@iconify/icons-fa-solid/grin-beam-sweat';
import grin_hearts from '@iconify/icons-fa-solid/grin-hearts';
import grin_squint from '@iconify/icons-fa-solid/grin-squint';
import grin_squint_tears from '@iconify/icons-fa-solid/grin-squint-tears';
import grin_stars from '@iconify/icons-fa-solid/grin-stars';
import grin_tears from '@iconify/icons-fa-solid/grin-tears';
import grin_tongue from '@iconify/icons-fa-solid/grin-tongue';
import grin_tongue_squint from '@iconify/icons-fa-solid/grin-tongue-squint';
import grin_tongue_wink from '@iconify/icons-fa-solid/grin-tongue-wink';
import grin_wink from '@iconify/icons-fa-solid/grin-wink';
import grip_horizontal from '@iconify/icons-fa-solid/grip-horizontal';
import grip_lines from '@iconify/icons-fa-solid/grip-lines';
import grip_lines_vertical from '@iconify/icons-fa-solid/grip-lines-vertical';
import grip_vertical from '@iconify/icons-fa-solid/grip-vertical';
import guitar from '@iconify/icons-fa-solid/guitar';
import h_square from '@iconify/icons-fa-solid/h-square';
import hamburger from '@iconify/icons-fa-solid/hamburger';
import hammer from '@iconify/icons-fa-solid/hammer';
import hamsa from '@iconify/icons-fa-solid/hamsa';
import hand_holding from '@iconify/icons-fa-solid/hand-holding';
import hand_holding_heart from '@iconify/icons-fa-solid/hand-holding-heart';
import hand_holding_usd from '@iconify/icons-fa-solid/hand-holding-usd';
import hand_lizard from '@iconify/icons-fa-solid/hand-lizard';
import hand_middle_finger from '@iconify/icons-fa-solid/hand-middle-finger';
import hand_paper from '@iconify/icons-fa-solid/hand-paper';
import hand_peace from '@iconify/icons-fa-solid/hand-peace';
import hand_point_down from '@iconify/icons-fa-solid/hand-point-down';
import hand_point_left from '@iconify/icons-fa-solid/hand-point-left';
import hand_point_right from '@iconify/icons-fa-solid/hand-point-right';
import hand_point_up from '@iconify/icons-fa-solid/hand-point-up';
import hand_pointer from '@iconify/icons-fa-solid/hand-pointer';
import hand_rock from '@iconify/icons-fa-solid/hand-rock';
import hand_scissors from '@iconify/icons-fa-solid/hand-scissors';
import hand_spock from '@iconify/icons-fa-solid/hand-spock';
import hands from '@iconify/icons-fa-solid/hands';
import hands_helping from '@iconify/icons-fa-solid/hands-helping';
import handshake from '@iconify/icons-fa-solid/handshake';
import hanukiah from '@iconify/icons-fa-solid/hanukiah';
import hard_hat from '@iconify/icons-fa-solid/hard-hat';
import hashtag from '@iconify/icons-fa-solid/hashtag';
import hat_wizard from '@iconify/icons-fa-solid/hat-wizard';
import haykal from '@iconify/icons-fa-solid/haykal';
import hdd from '@iconify/icons-fa-solid/hdd';
import heading from '@iconify/icons-fa-solid/heading';
import headphones from '@iconify/icons-fa-solid/headphones';
import headphones_alt from '@iconify/icons-fa-solid/headphones-alt';
import headset from '@iconify/icons-fa-solid/headset';
import heart from '@iconify/icons-fa-solid/heart';
import heart_broken from '@iconify/icons-fa-solid/heart-broken';
import heartbeat from '@iconify/icons-fa-solid/heartbeat';
import helicopter from '@iconify/icons-fa-solid/helicopter';
import highlighter from '@iconify/icons-fa-solid/highlighter';
import hiking from '@iconify/icons-fa-solid/hiking';
import hippo from '@iconify/icons-fa-solid/hippo';
import history from '@iconify/icons-fa-solid/history';
import hockey_puck from '@iconify/icons-fa-solid/hockey-puck';
import holly_berry from '@iconify/icons-fa-solid/holly-berry';
import home from '@iconify/icons-fa-solid/home';
import horse from '@iconify/icons-fa-solid/horse';
import horse_head from '@iconify/icons-fa-solid/horse-head';
import hospital from '@iconify/icons-fa-solid/hospital';
import hospital_alt from '@iconify/icons-fa-solid/hospital-alt';
import hospital_symbol from '@iconify/icons-fa-solid/hospital-symbol';
import hot_tub from '@iconify/icons-fa-solid/hot-tub';
import hotdog from '@iconify/icons-fa-solid/hotdog';
import hotel from '@iconify/icons-fa-solid/hotel';
import hourglass from '@iconify/icons-fa-solid/hourglass';
import hourglass_end from '@iconify/icons-fa-solid/hourglass-end';
import hourglass_half from '@iconify/icons-fa-solid/hourglass-half';
import hourglass_start from '@iconify/icons-fa-solid/hourglass-start';
import house_damage from '@iconify/icons-fa-solid/house-damage';
import hryvnia from '@iconify/icons-fa-solid/hryvnia';
import i_cursor from '@iconify/icons-fa-solid/i-cursor';
import ice_cream from '@iconify/icons-fa-solid/ice-cream';
import icicles from '@iconify/icons-fa-solid/icicles';
import icons from '@iconify/icons-fa-solid/icons';
import id_badge from '@iconify/icons-fa-solid/id-badge';
import id_card from '@iconify/icons-fa-solid/id-card';
import id_card_alt from '@iconify/icons-fa-solid/id-card-alt';
import igloo from '@iconify/icons-fa-solid/igloo';
import image from '@iconify/icons-fa-solid/image';
import images from '@iconify/icons-fa-solid/images';
import inbox from '@iconify/icons-fa-solid/inbox';
import indent from '@iconify/icons-fa-solid/indent';
import industry from '@iconify/icons-fa-solid/industry';
import infinity from '@iconify/icons-fa-solid/infinity';
import info from '@iconify/icons-fa-solid/info';
import info_circle from '@iconify/icons-fa-solid/info-circle';
import italic from '@iconify/icons-fa-solid/italic';
import jedi from '@iconify/icons-fa-solid/jedi';
import joint from '@iconify/icons-fa-solid/joint';
import journal_whills from '@iconify/icons-fa-solid/journal-whills';
import kaaba from '@iconify/icons-fa-solid/kaaba';
import key from '@iconify/icons-fa-solid/key';
import keyboard from '@iconify/icons-fa-solid/keyboard';
import khanda from '@iconify/icons-fa-solid/khanda';
import kiss from '@iconify/icons-fa-solid/kiss';
import kiss_beam from '@iconify/icons-fa-solid/kiss-beam';
import kiss_wink_heart from '@iconify/icons-fa-solid/kiss-wink-heart';
import kiwi_bird from '@iconify/icons-fa-solid/kiwi-bird';
import landmark from '@iconify/icons-fa-solid/landmark';
import language from '@iconify/icons-fa-solid/language';
import laptop from '@iconify/icons-fa-solid/laptop';
import laptop_code from '@iconify/icons-fa-solid/laptop-code';
import laptop_medical from '@iconify/icons-fa-solid/laptop-medical';
import laugh from '@iconify/icons-fa-solid/laugh';
import laugh_beam from '@iconify/icons-fa-solid/laugh-beam';
import laugh_squint from '@iconify/icons-fa-solid/laugh-squint';
import laugh_wink from '@iconify/icons-fa-solid/laugh-wink';
import layer_group from '@iconify/icons-fa-solid/layer-group';
import leaf from '@iconify/icons-fa-solid/leaf';
import lemon from '@iconify/icons-fa-solid/lemon';
import less_than from '@iconify/icons-fa-solid/less-than';
import less_than_equal from '@iconify/icons-fa-solid/less-than-equal';
import level_down_alt from '@iconify/icons-fa-solid/level-down-alt';
import level_up_alt from '@iconify/icons-fa-solid/level-up-alt';
import life_ring from '@iconify/icons-fa-solid/life-ring';
import lightbulb from '@iconify/icons-fa-solid/lightbulb';
import link from '@iconify/icons-fa-solid/link';
import lira_sign from '@iconify/icons-fa-solid/lira-sign';
import list from '@iconify/icons-fa-solid/list';
import list_alt from '@iconify/icons-fa-solid/list-alt';
import list_ol from '@iconify/icons-fa-solid/list-ol';
import list_ul from '@iconify/icons-fa-solid/list-ul';
import location_arrow from '@iconify/icons-fa-solid/location-arrow';
import lock from '@iconify/icons-fa-solid/lock';
import lock_open from '@iconify/icons-fa-solid/lock-open';
import long_arrow_alt_down from '@iconify/icons-fa-solid/long-arrow-alt-down';
import long_arrow_alt_left from '@iconify/icons-fa-solid/long-arrow-alt-left';
import long_arrow_alt_right from '@iconify/icons-fa-solid/long-arrow-alt-right';
import long_arrow_alt_up from '@iconify/icons-fa-solid/long-arrow-alt-up';
import low_vision from '@iconify/icons-fa-solid/low-vision';
import luggage_cart from '@iconify/icons-fa-solid/luggage-cart';
import magic from '@iconify/icons-fa-solid/magic';
import magnet from '@iconify/icons-fa-solid/magnet';
import mail_bulk from '@iconify/icons-fa-solid/mail-bulk';
import male from '@iconify/icons-fa-solid/male';
import map from '@iconify/icons-fa-solid/map';
import map_marked from '@iconify/icons-fa-solid/map-marked';
import map_marked_alt from '@iconify/icons-fa-solid/map-marked-alt';
import map_marker from '@iconify/icons-fa-solid/map-marker';
import map_marker_alt from '@iconify/icons-fa-solid/map-marker-alt';
import map_pin from '@iconify/icons-fa-solid/map-pin';
import map_signs from '@iconify/icons-fa-solid/map-signs';
import marker from '@iconify/icons-fa-solid/marker';
import mars from '@iconify/icons-fa-solid/mars';
import mars_double from '@iconify/icons-fa-solid/mars-double';
import mars_stroke from '@iconify/icons-fa-solid/mars-stroke';
import mars_stroke_h from '@iconify/icons-fa-solid/mars-stroke-h';
import mars_stroke_v from '@iconify/icons-fa-solid/mars-stroke-v';
import mask from '@iconify/icons-fa-solid/mask';
import medal from '@iconify/icons-fa-solid/medal';
import medkit from '@iconify/icons-fa-solid/medkit';
import meh from '@iconify/icons-fa-solid/meh';
import meh_blank from '@iconify/icons-fa-solid/meh-blank';
import meh_rolling_eyes from '@iconify/icons-fa-solid/meh-rolling-eyes';
import memory from '@iconify/icons-fa-solid/memory';
import menorah from '@iconify/icons-fa-solid/menorah';
import mercury from '@iconify/icons-fa-solid/mercury';
import meteor from '@iconify/icons-fa-solid/meteor';
import microchip from '@iconify/icons-fa-solid/microchip';
import microphone from '@iconify/icons-fa-solid/microphone';
import microphone_alt from '@iconify/icons-fa-solid/microphone-alt';
import microphone_alt_slash from '@iconify/icons-fa-solid/microphone-alt-slash';
import microphone_slash from '@iconify/icons-fa-solid/microphone-slash';
import microscope from '@iconify/icons-fa-solid/microscope';
import minus from '@iconify/icons-fa-solid/minus';
import minus_circle from '@iconify/icons-fa-solid/minus-circle';
import minus_square from '@iconify/icons-fa-solid/minus-square';
import mitten from '@iconify/icons-fa-solid/mitten';
import mobile from '@iconify/icons-fa-solid/mobile';
import mobile_alt from '@iconify/icons-fa-solid/mobile-alt';
import money_bill from '@iconify/icons-fa-solid/money-bill';
import money_bill_alt from '@iconify/icons-fa-solid/money-bill-alt';
import money_bill_wave from '@iconify/icons-fa-solid/money-bill-wave';
import money_bill_wave_alt from '@iconify/icons-fa-solid/money-bill-wave-alt';
import money_check from '@iconify/icons-fa-solid/money-check';
import money_check_alt from '@iconify/icons-fa-solid/money-check-alt';
import monument from '@iconify/icons-fa-solid/monument';
import moon from '@iconify/icons-fa-solid/moon';
import mortar_pestle from '@iconify/icons-fa-solid/mortar-pestle';
import mosque from '@iconify/icons-fa-solid/mosque';
import motorcycle from '@iconify/icons-fa-solid/motorcycle';
import mountain from '@iconify/icons-fa-solid/mountain';
import mouse_pointer from '@iconify/icons-fa-solid/mouse-pointer';
import mug_hot from '@iconify/icons-fa-solid/mug-hot';
import music from '@iconify/icons-fa-solid/music';
import network_wired from '@iconify/icons-fa-solid/network-wired';
import neuter from '@iconify/icons-fa-solid/neuter';
import newspaper from '@iconify/icons-fa-solid/newspaper';
import not_equal from '@iconify/icons-fa-solid/not-equal';
import notes_medical from '@iconify/icons-fa-solid/notes-medical';
import object_group from '@iconify/icons-fa-solid/object-group';
import object_ungroup from '@iconify/icons-fa-solid/object-ungroup';
import oil_can from '@iconify/icons-fa-solid/oil-can';
import om from '@iconify/icons-fa-solid/om';
import otter from '@iconify/icons-fa-solid/otter';
import outdent from '@iconify/icons-fa-solid/outdent';
import pager from '@iconify/icons-fa-solid/pager';
import paint_brush from '@iconify/icons-fa-solid/paint-brush';
import paint_roller from '@iconify/icons-fa-solid/paint-roller';
import palette from '@iconify/icons-fa-solid/palette';
import pallet from '@iconify/icons-fa-solid/pallet';
import paper_plane from '@iconify/icons-fa-solid/paper-plane';
import paperclip from '@iconify/icons-fa-solid/paperclip';
import parachute_box from '@iconify/icons-fa-solid/parachute-box';
import paragraph from '@iconify/icons-fa-solid/paragraph';
import parking from '@iconify/icons-fa-solid/parking';
import passport from '@iconify/icons-fa-solid/passport';
import pastafarianism from '@iconify/icons-fa-solid/pastafarianism';
import paste from '@iconify/icons-fa-solid/paste';
import pause from '@iconify/icons-fa-solid/pause';
import pause_circle from '@iconify/icons-fa-solid/pause-circle';
import paw from '@iconify/icons-fa-solid/paw';
import peace from '@iconify/icons-fa-solid/peace';
import pen from '@iconify/icons-fa-solid/pen';
import pen_alt from '@iconify/icons-fa-solid/pen-alt';
import pen_fancy from '@iconify/icons-fa-solid/pen-fancy';
import pen_nib from '@iconify/icons-fa-solid/pen-nib';
import pen_square from '@iconify/icons-fa-solid/pen-square';
import pencil_alt from '@iconify/icons-fa-solid/pencil-alt';
import pencil_ruler from '@iconify/icons-fa-solid/pencil-ruler';
import people_carry from '@iconify/icons-fa-solid/people-carry';
import pepper_hot from '@iconify/icons-fa-solid/pepper-hot';
import percent from '@iconify/icons-fa-solid/percent';
import percentage from '@iconify/icons-fa-solid/percentage';
import person_booth from '@iconify/icons-fa-solid/person-booth';
import phone from '@iconify/icons-fa-solid/phone';
import phone_alt from '@iconify/icons-fa-solid/phone-alt';
import phone_slash from '@iconify/icons-fa-solid/phone-slash';
import phone_square from '@iconify/icons-fa-solid/phone-square';
import phone_square_alt from '@iconify/icons-fa-solid/phone-square-alt';
import phone_volume from '@iconify/icons-fa-solid/phone-volume';
import photo_video from '@iconify/icons-fa-solid/photo-video';
import piggy_bank from '@iconify/icons-fa-solid/piggy-bank';
import pills from '@iconify/icons-fa-solid/pills';
import pizza_slice from '@iconify/icons-fa-solid/pizza-slice';
import place_of_worship from '@iconify/icons-fa-solid/place-of-worship';
import plane from '@iconify/icons-fa-solid/plane';
import plane_arrival from '@iconify/icons-fa-solid/plane-arrival';
import plane_departure from '@iconify/icons-fa-solid/plane-departure';
import play from '@iconify/icons-fa-solid/play';
import play_circle from '@iconify/icons-fa-solid/play-circle';
import plug from '@iconify/icons-fa-solid/plug';
import plus from '@iconify/icons-fa-solid/plus';
import plus_circle from '@iconify/icons-fa-solid/plus-circle';
import plus_square from '@iconify/icons-fa-solid/plus-square';
import podcast from '@iconify/icons-fa-solid/podcast';
import poll from '@iconify/icons-fa-solid/poll';
import poll_h from '@iconify/icons-fa-solid/poll-h';
import poo from '@iconify/icons-fa-solid/poo';
import poo_storm from '@iconify/icons-fa-solid/poo-storm';
import poop from '@iconify/icons-fa-solid/poop';
import portrait from '@iconify/icons-fa-solid/portrait';
import pound_sign from '@iconify/icons-fa-solid/pound-sign';
import power_off from '@iconify/icons-fa-solid/power-off';
import pray from '@iconify/icons-fa-solid/pray';
import praying_hands from '@iconify/icons-fa-solid/praying-hands';
import prescription from '@iconify/icons-fa-solid/prescription';
import prescription_bottle from '@iconify/icons-fa-solid/prescription-bottle';
import prescription_bottle_alt from '@iconify/icons-fa-solid/prescription-bottle-alt';
import print from '@iconify/icons-fa-solid/print';
import procedures from '@iconify/icons-fa-solid/procedures';
import project_diagram from '@iconify/icons-fa-solid/project-diagram';
import puzzle_piece from '@iconify/icons-fa-solid/puzzle-piece';
import qrcode from '@iconify/icons-fa-solid/qrcode';
import question from '@iconify/icons-fa-solid/question';
import question_circle from '@iconify/icons-fa-solid/question-circle';
import quidditch from '@iconify/icons-fa-solid/quidditch';
import quote_left from '@iconify/icons-fa-solid/quote-left';
import quote_right from '@iconify/icons-fa-solid/quote-right';
import quran from '@iconify/icons-fa-solid/quran';
import radiation from '@iconify/icons-fa-solid/radiation';
import radiation_alt from '@iconify/icons-fa-solid/radiation-alt';
import rainbow from '@iconify/icons-fa-solid/rainbow';
import random from '@iconify/icons-fa-solid/random';
import receipt from '@iconify/icons-fa-solid/receipt';
import recycle from '@iconify/icons-fa-solid/recycle';
import redo from '@iconify/icons-fa-solid/redo';
import redo_alt from '@iconify/icons-fa-solid/redo-alt';
import registered from '@iconify/icons-fa-solid/registered';
import remove_format from '@iconify/icons-fa-solid/remove-format';
import reply from '@iconify/icons-fa-solid/reply';
import reply_all from '@iconify/icons-fa-solid/reply-all';
import republican from '@iconify/icons-fa-solid/republican';
import restroom from '@iconify/icons-fa-solid/restroom';
import retweet from '@iconify/icons-fa-solid/retweet';
import ribbon from '@iconify/icons-fa-solid/ribbon';
import ring from '@iconify/icons-fa-solid/ring';
import road from '@iconify/icons-fa-solid/road';
import robot from '@iconify/icons-fa-solid/robot';
import rocket from '@iconify/icons-fa-solid/rocket';
import route from '@iconify/icons-fa-solid/route';
import rss from '@iconify/icons-fa-solid/rss';
import rss_square from '@iconify/icons-fa-solid/rss-square';
import ruble_sign from '@iconify/icons-fa-solid/ruble-sign';
import ruler from '@iconify/icons-fa-solid/ruler';
import ruler_combined from '@iconify/icons-fa-solid/ruler-combined';
import ruler_horizontal from '@iconify/icons-fa-solid/ruler-horizontal';
import ruler_vertical from '@iconify/icons-fa-solid/ruler-vertical';
import running from '@iconify/icons-fa-solid/running';
import rupee_sign from '@iconify/icons-fa-solid/rupee-sign';
import sad_cry from '@iconify/icons-fa-solid/sad-cry';
import sad_tear from '@iconify/icons-fa-solid/sad-tear';
import satellite from '@iconify/icons-fa-solid/satellite';
import satellite_dish from '@iconify/icons-fa-solid/satellite-dish';
import save from '@iconify/icons-fa-solid/save';
import school from '@iconify/icons-fa-solid/school';
import screwdriver from '@iconify/icons-fa-solid/screwdriver';
import scroll from '@iconify/icons-fa-solid/scroll';
import sd_card from '@iconify/icons-fa-solid/sd-card';
import search from '@iconify/icons-fa-solid/search';
import search_dollar from '@iconify/icons-fa-solid/search-dollar';
import search_location from '@iconify/icons-fa-solid/search-location';
import search_minus from '@iconify/icons-fa-solid/search-minus';
import search_plus from '@iconify/icons-fa-solid/search-plus';
import seedling from '@iconify/icons-fa-solid/seedling';
import server from '@iconify/icons-fa-solid/server';
import shapes from '@iconify/icons-fa-solid/shapes';
import share from '@iconify/icons-fa-solid/share';
import share_alt from '@iconify/icons-fa-solid/share-alt';
import share_alt_square from '@iconify/icons-fa-solid/share-alt-square';
import share_square from '@iconify/icons-fa-solid/share-square';
import shekel_sign from '@iconify/icons-fa-solid/shekel-sign';
import shield_alt from '@iconify/icons-fa-solid/shield-alt';
import ship from '@iconify/icons-fa-solid/ship';
import shipping_fast from '@iconify/icons-fa-solid/shipping-fast';
import shoe_prints from '@iconify/icons-fa-solid/shoe-prints';
import shopping_bag from '@iconify/icons-fa-solid/shopping-bag';
import shopping_basket from '@iconify/icons-fa-solid/shopping-basket';
import shopping_cart from '@iconify/icons-fa-solid/shopping-cart';
import shower from '@iconify/icons-fa-solid/shower';
import shuttle_van from '@iconify/icons-fa-solid/shuttle-van';
import sign from '@iconify/icons-fa-solid/sign';
import sign_in_alt from '@iconify/icons-fa-solid/sign-in-alt';
import sign_language from '@iconify/icons-fa-solid/sign-language';
import sign_out_alt from '@iconify/icons-fa-solid/sign-out-alt';
import signal from '@iconify/icons-fa-solid/signal';
import signature from '@iconify/icons-fa-solid/signature';
import sim_card from '@iconify/icons-fa-solid/sim-card';
import sitemap from '@iconify/icons-fa-solid/sitemap';
import skating from '@iconify/icons-fa-solid/skating';
import skiing from '@iconify/icons-fa-solid/skiing';
import skiing_nordic from '@iconify/icons-fa-solid/skiing-nordic';
import skull from '@iconify/icons-fa-solid/skull';
import skull_crossbones from '@iconify/icons-fa-solid/skull-crossbones';
import slash from '@iconify/icons-fa-solid/slash';
import sleigh from '@iconify/icons-fa-solid/sleigh';
import sliders_h from '@iconify/icons-fa-solid/sliders-h';
import smile from '@iconify/icons-fa-solid/smile';
import smile_beam from '@iconify/icons-fa-solid/smile-beam';
import smile_wink from '@iconify/icons-fa-solid/smile-wink';
import smog from '@iconify/icons-fa-solid/smog';
import smoking from '@iconify/icons-fa-solid/smoking';
import smoking_ban from '@iconify/icons-fa-solid/smoking-ban';
import sms from '@iconify/icons-fa-solid/sms';
import snowboarding from '@iconify/icons-fa-solid/snowboarding';
import snowflake from '@iconify/icons-fa-solid/snowflake';
import snowman from '@iconify/icons-fa-solid/snowman';
import snowplow from '@iconify/icons-fa-solid/snowplow';
import socks from '@iconify/icons-fa-solid/socks';
import solar_panel from '@iconify/icons-fa-solid/solar-panel';
import sort from '@iconify/icons-fa-solid/sort';
import sort_alpha_down from '@iconify/icons-fa-solid/sort-alpha-down';
import sort_alpha_down_alt from '@iconify/icons-fa-solid/sort-alpha-down-alt';
import sort_alpha_up from '@iconify/icons-fa-solid/sort-alpha-up';
import sort_alpha_up_alt from '@iconify/icons-fa-solid/sort-alpha-up-alt';
import sort_amount_down from '@iconify/icons-fa-solid/sort-amount-down';
import sort_amount_down_alt from '@iconify/icons-fa-solid/sort-amount-down-alt';
import sort_amount_up from '@iconify/icons-fa-solid/sort-amount-up';
import sort_amount_up_alt from '@iconify/icons-fa-solid/sort-amount-up-alt';
import sort_down from '@iconify/icons-fa-solid/sort-down';
import sort_numeric_down from '@iconify/icons-fa-solid/sort-numeric-down';
import sort_numeric_down_alt from '@iconify/icons-fa-solid/sort-numeric-down-alt';
import sort_numeric_up from '@iconify/icons-fa-solid/sort-numeric-up';
import sort_numeric_up_alt from '@iconify/icons-fa-solid/sort-numeric-up-alt';
import sort_up from '@iconify/icons-fa-solid/sort-up';
import spa from '@iconify/icons-fa-solid/spa';
import space_shuttle from '@iconify/icons-fa-solid/space-shuttle';
import spell_check from '@iconify/icons-fa-solid/spell-check';
import spider from '@iconify/icons-fa-solid/spider';
import spinner from '@iconify/icons-fa-solid/spinner';
import splotch from '@iconify/icons-fa-solid/splotch';
import spray_can from '@iconify/icons-fa-solid/spray-can';
import square from '@iconify/icons-fa-solid/square';
import square_full from '@iconify/icons-fa-solid/square-full';
import square_root_alt from '@iconify/icons-fa-solid/square-root-alt';
import stamp from '@iconify/icons-fa-solid/stamp';
import star from '@iconify/icons-fa-solid/star';
import star_and_crescent from '@iconify/icons-fa-solid/star-and-crescent';
import star_half from '@iconify/icons-fa-solid/star-half';
import star_half_alt from '@iconify/icons-fa-solid/star-half-alt';
import star_of_david from '@iconify/icons-fa-solid/star-of-david';
import star_of_life from '@iconify/icons-fa-solid/star-of-life';
import step_backward from '@iconify/icons-fa-solid/step-backward';
import step_forward from '@iconify/icons-fa-solid/step-forward';
import stethoscope from '@iconify/icons-fa-solid/stethoscope';
import sticky_note from '@iconify/icons-fa-solid/sticky-note';
import stop from '@iconify/icons-fa-solid/stop';
import stop_circle from '@iconify/icons-fa-solid/stop-circle';
import stopwatch from '@iconify/icons-fa-solid/stopwatch';
import store from '@iconify/icons-fa-solid/store';
import store_alt from '@iconify/icons-fa-solid/store-alt';
import stream from '@iconify/icons-fa-solid/stream';
import street_view from '@iconify/icons-fa-solid/street-view';
import strikethrough from '@iconify/icons-fa-solid/strikethrough';
import stroopwafel from '@iconify/icons-fa-solid/stroopwafel';
import subscript from '@iconify/icons-fa-solid/subscript';
import subway from '@iconify/icons-fa-solid/subway';
import suitcase from '@iconify/icons-fa-solid/suitcase';
import suitcase_rolling from '@iconify/icons-fa-solid/suitcase-rolling';
import sun from '@iconify/icons-fa-solid/sun';
import superscript from '@iconify/icons-fa-solid/superscript';
import surprise from '@iconify/icons-fa-solid/surprise';
import swatchbook from '@iconify/icons-fa-solid/swatchbook';
import swimmer from '@iconify/icons-fa-solid/swimmer';
import swimming_pool from '@iconify/icons-fa-solid/swimming-pool';
import synagogue from '@iconify/icons-fa-solid/synagogue';
import sync from '@iconify/icons-fa-solid/sync';
import sync_alt from '@iconify/icons-fa-solid/sync-alt';
import syringe from '@iconify/icons-fa-solid/syringe';
import table from '@iconify/icons-fa-solid/table';
import table_tennis from '@iconify/icons-fa-solid/table-tennis';
import tablet from '@iconify/icons-fa-solid/tablet';
import tablet_alt from '@iconify/icons-fa-solid/tablet-alt';
import tablets from '@iconify/icons-fa-solid/tablets';
import tachometer_alt from '@iconify/icons-fa-solid/tachometer-alt';
import tag from '@iconify/icons-fa-solid/tag';
import tags from '@iconify/icons-fa-solid/tags';
import tape from '@iconify/icons-fa-solid/tape';
import tasks from '@iconify/icons-fa-solid/tasks';
import taxi from '@iconify/icons-fa-solid/taxi';
import teeth from '@iconify/icons-fa-solid/teeth';
import teeth_open from '@iconify/icons-fa-solid/teeth-open';
import temperature_high from '@iconify/icons-fa-solid/temperature-high';
import temperature_low from '@iconify/icons-fa-solid/temperature-low';
import tenge from '@iconify/icons-fa-solid/tenge';
import terminal from '@iconify/icons-fa-solid/terminal';
import text_height from '@iconify/icons-fa-solid/text-height';
import text_width from '@iconify/icons-fa-solid/text-width';
import th from '@iconify/icons-fa-solid/th';
import th_large from '@iconify/icons-fa-solid/th-large';
import th_list from '@iconify/icons-fa-solid/th-list';
import theater_masks from '@iconify/icons-fa-solid/theater-masks';
import thermometer from '@iconify/icons-fa-solid/thermometer';
import thermometer_empty from '@iconify/icons-fa-solid/thermometer-empty';
import thermometer_full from '@iconify/icons-fa-solid/thermometer-full';
import thermometer_half from '@iconify/icons-fa-solid/thermometer-half';
import thermometer_quarter from '@iconify/icons-fa-solid/thermometer-quarter';
import thermometer_three_quarters from '@iconify/icons-fa-solid/thermometer-three-quarters';
import thumbs_down from '@iconify/icons-fa-solid/thumbs-down';
import thumbs_up from '@iconify/icons-fa-solid/thumbs-up';
import thumbtack from '@iconify/icons-fa-solid/thumbtack';
import ticket_alt from '@iconify/icons-fa-solid/ticket-alt';
import times from '@iconify/icons-fa-solid/times';
import times_circle from '@iconify/icons-fa-solid/times-circle';
import tint from '@iconify/icons-fa-solid/tint';
import tint_slash from '@iconify/icons-fa-solid/tint-slash';
import tired from '@iconify/icons-fa-solid/tired';
import toggle_off from '@iconify/icons-fa-solid/toggle-off';
import toggle_on from '@iconify/icons-fa-solid/toggle-on';
import toilet from '@iconify/icons-fa-solid/toilet';
import toilet_paper from '@iconify/icons-fa-solid/toilet-paper';
import toolbox from '@iconify/icons-fa-solid/toolbox';
import tools from '@iconify/icons-fa-solid/tools';
import tooth from '@iconify/icons-fa-solid/tooth';
import torah from '@iconify/icons-fa-solid/torah';
import torii_gate from '@iconify/icons-fa-solid/torii-gate';
import tractor from '@iconify/icons-fa-solid/tractor';
import trademark from '@iconify/icons-fa-solid/trademark';
import traffic_light from '@iconify/icons-fa-solid/traffic-light';
import train from '@iconify/icons-fa-solid/train';
import tram from '@iconify/icons-fa-solid/tram';
import transgender from '@iconify/icons-fa-solid/transgender';
import transgender_alt from '@iconify/icons-fa-solid/transgender-alt';
import trash from '@iconify/icons-fa-solid/trash';
import trash_alt from '@iconify/icons-fa-solid/trash-alt';
import trash_restore from '@iconify/icons-fa-solid/trash-restore';
import trash_restore_alt from '@iconify/icons-fa-solid/trash-restore-alt';
import tree from '@iconify/icons-fa-solid/tree';
import trophy from '@iconify/icons-fa-solid/trophy';
import truck from '@iconify/icons-fa-solid/truck';
import truck_loading from '@iconify/icons-fa-solid/truck-loading';
import truck_monster from '@iconify/icons-fa-solid/truck-monster';
import truck_moving from '@iconify/icons-fa-solid/truck-moving';
import truck_pickup from '@iconify/icons-fa-solid/truck-pickup';
import tshirt from '@iconify/icons-fa-solid/tshirt';
import tty from '@iconify/icons-fa-solid/tty';
import tv from '@iconify/icons-fa-solid/tv';
import umbrella from '@iconify/icons-fa-solid/umbrella';
import umbrella_beach from '@iconify/icons-fa-solid/umbrella-beach';
import underline from '@iconify/icons-fa-solid/underline';
import undo from '@iconify/icons-fa-solid/undo';
import undo_alt from '@iconify/icons-fa-solid/undo-alt';
import universal_access from '@iconify/icons-fa-solid/universal-access';
import university from '@iconify/icons-fa-solid/university';
import unlink from '@iconify/icons-fa-solid/unlink';
import unlock from '@iconify/icons-fa-solid/unlock';
import unlock_alt from '@iconify/icons-fa-solid/unlock-alt';
import upload from '@iconify/icons-fa-solid/upload';
import user from '@iconify/icons-fa-solid/user';
import user_alt from '@iconify/icons-fa-solid/user-alt';
import user_alt_slash from '@iconify/icons-fa-solid/user-alt-slash';
import user_astronaut from '@iconify/icons-fa-solid/user-astronaut';
import user_check from '@iconify/icons-fa-solid/user-check';
import user_circle from '@iconify/icons-fa-solid/user-circle';
import user_clock from '@iconify/icons-fa-solid/user-clock';
import user_cog from '@iconify/icons-fa-solid/user-cog';
import user_edit from '@iconify/icons-fa-solid/user-edit';
import user_friends from '@iconify/icons-fa-solid/user-friends';
import user_graduate from '@iconify/icons-fa-solid/user-graduate';
import user_injured from '@iconify/icons-fa-solid/user-injured';
import user_lock from '@iconify/icons-fa-solid/user-lock';
import user_md from '@iconify/icons-fa-solid/user-md';
import user_minus from '@iconify/icons-fa-solid/user-minus';
import user_ninja from '@iconify/icons-fa-solid/user-ninja';
import user_nurse from '@iconify/icons-fa-solid/user-nurse';
import user_plus from '@iconify/icons-fa-solid/user-plus';
import user_secret from '@iconify/icons-fa-solid/user-secret';
import user_shield from '@iconify/icons-fa-solid/user-shield';
import user_slash from '@iconify/icons-fa-solid/user-slash';
import user_tag from '@iconify/icons-fa-solid/user-tag';
import user_tie from '@iconify/icons-fa-solid/user-tie';
import user_times from '@iconify/icons-fa-solid/user-times';
import users from '@iconify/icons-fa-solid/users';
import users_cog from '@iconify/icons-fa-solid/users-cog';
import utensil_spoon from '@iconify/icons-fa-solid/utensil-spoon';
import utensils from '@iconify/icons-fa-solid/utensils';
import vector_square from '@iconify/icons-fa-solid/vector-square';
import venus from '@iconify/icons-fa-solid/venus';
import venus_double from '@iconify/icons-fa-solid/venus-double';
import venus_mars from '@iconify/icons-fa-solid/venus-mars';
import vial from '@iconify/icons-fa-solid/vial';
import vials from '@iconify/icons-fa-solid/vials';
import video from '@iconify/icons-fa-solid/video';
import video_slash from '@iconify/icons-fa-solid/video-slash';
import vihara from '@iconify/icons-fa-solid/vihara';
import voicemail from '@iconify/icons-fa-solid/voicemail';
import volleyball_ball from '@iconify/icons-fa-solid/volleyball-ball';
import volume_down from '@iconify/icons-fa-solid/volume-down';
import volume_mute from '@iconify/icons-fa-solid/volume-mute';
import volume_off from '@iconify/icons-fa-solid/volume-off';
import volume_up from '@iconify/icons-fa-solid/volume-up';
import vote_yea from '@iconify/icons-fa-solid/vote-yea';
import vr_cardboard from '@iconify/icons-fa-solid/vr-cardboard';
import walking from '@iconify/icons-fa-solid/walking';
import wallet from '@iconify/icons-fa-solid/wallet';
import warehouse from '@iconify/icons-fa-solid/warehouse';
import water from '@iconify/icons-fa-solid/water';
import wave_square from '@iconify/icons-fa-solid/wave-square';
import weight from '@iconify/icons-fa-solid/weight';
import weight_hanging from '@iconify/icons-fa-solid/weight-hanging';
import wheelchair from '@iconify/icons-fa-solid/wheelchair';
import wifi from '@iconify/icons-fa-solid/wifi';
import wind from '@iconify/icons-fa-solid/wind';
import window_close from '@iconify/icons-fa-solid/window-close';
import window_maximize from '@iconify/icons-fa-solid/window-maximize';
import window_minimize from '@iconify/icons-fa-solid/window-minimize';
import window_restore from '@iconify/icons-fa-solid/window-restore';
import wine_bottle from '@iconify/icons-fa-solid/wine-bottle';
import wine_glass from '@iconify/icons-fa-solid/wine-glass';
import wine_glass_alt from '@iconify/icons-fa-solid/wine-glass-alt';
import won_sign from '@iconify/icons-fa-solid/won-sign';
import wrench from '@iconify/icons-fa-solid/wrench';
import x_ray from '@iconify/icons-fa-solid/x-ray';
import yen_sign from '@iconify/icons-fa-solid/yen-sign';
import yin_yang from '@iconify/icons-fa-solid/yin-yang';

export const iconsFA = {
  ad: ad,
  'address-book': address_book,
  'address-card': address_card,
  adjust: adjust,
  'air-freshener': air_freshener,
  'align-center': align_center,
  'align-justify': align_justify,
  'align-left': align_left,
  'align-right': align_right,
  allergies: allergies,
  ambulance: ambulance,
  'american-sign-language-interpreting': american_sign_language_interpreting,
  anchor: anchor,
  'angle-double-down': angle_double_down,
  'angle-double-left': angle_double_left,
  'angle-double-right': angle_double_right,
  'angle-double-up': angle_double_up,
  'angle-down': angle_down,
  'angle-left': angle_left,
  'angle-right': angle_right,
  'angle-up': angle_up,
  angry: angry,
  ankh: ankh,
  'apple-alt': apple_alt,
  archive: archive,
  archway: archway,
  'arrow-alt-circle-down': arrow_alt_circle_down,
  'arrow-alt-circle-left': arrow_alt_circle_left,
  'arrow-alt-circle-right': arrow_alt_circle_right,
  'arrow-alt-circle-up': arrow_alt_circle_up,
  'arrow-circle-down': arrow_circle_down,
  'arrow-circle-left': arrow_circle_left,
  'arrow-circle-right': arrow_circle_right,
  'arrow-circle-up': arrow_circle_up,
  'arrow-down': arrow_down,
  'arrow-left': arrow_left,
  'arrow-right': arrow_right,
  'arrow-up': arrow_up,
  'arrows-alt': arrows_alt,
  'arrows-alt-h': arrows_alt_h,
  'arrows-alt-v': arrows_alt_v,
  'assistive-listening-systems': assistive_listening_systems,
  asterisk: asterisk,
  at: at,
  atlas: atlas,
  atom: atom,
  'audio-description': audio_description,
  award: award,
  baby: baby,
  'baby-carriage': baby_carriage,
  backspace: backspace,
  backward: backward,
  bacon: bacon,
  'balance-scale': balance_scale,
  'balance-scale-left': balance_scale_left,
  'balance-scale-right': balance_scale_right,
  ban: ban,
  'band-aid': band_aid,
  barcode: barcode,
  bars: bars,
  'baseball-ball': baseball_ball,
  'basketball-ball': basketball_ball,
  bath: bath,
  'battery-empty': battery_empty,
  'battery-full': battery_full,
  'battery-half': battery_half,
  'battery-quarter': battery_quarter,
  'battery-three-quarters': battery_three_quarters,
  bed: bed,
  beer: beer,
  bell: bell,
  'bell-slash': bell_slash,
  'bezier-curve': bezier_curve,
  bible: bible,
  bicycle: bicycle,
  biking: biking,
  binoculars: binoculars,
  biohazard: biohazard,
  'birthday-cake': birthday_cake,
  blender: blender,
  'blender-phone': blender_phone,
  blind: blind,
  blog: blog,
  bold: bold,
  bolt: bolt,
  bomb: bomb,
  bone: bone,
  bong: bong,
  book: book,
  'book-dead': book_dead,
  'book-medical': book_medical,
  'book-open': book_open,
  'book-reader': book_reader,
  bookmark: bookmark,
  'border-all': border_all,
  'border-none': border_none,
  'border-style': border_style,
  'bowling-ball': bowling_ball,
  box: box,
  'box-open': box_open,
  boxes: boxes,
  braille: braille,
  brain: brain,
  'bread-slice': bread_slice,
  briefcase: briefcase,
  'briefcase-medical': briefcase_medical,
  'broadcast-tower': broadcast_tower,
  broom: broom,
  brush: brush,
  bug: bug,
  building: building,
  bullhorn: bullhorn,
  bullseye: bullseye,
  burn: burn,
  bus: bus,
  'bus-alt': bus_alt,
  'business-time': business_time,
  calculator: calculator,
  calendar: calendar,
  'calendar-alt': calendar_alt,
  'calendar-check': calendar_check,
  'calendar-day': calendar_day,
  'calendar-minus': calendar_minus,
  'calendar-plus': calendar_plus,
  'calendar-times': calendar_times,
  'calendar-week': calendar_week,
  camera: camera,
  'camera-retro': camera_retro,
  campground: campground,
  'candy-cane': candy_cane,
  cannabis: cannabis,
  capsules: capsules,
  car: car,
  'car-alt': car_alt,
  'car-battery': car_battery,
  'car-crash': car_crash,
  'car-side': car_side,
  'caret-down': caret_down,
  'caret-left': caret_left,
  'caret-right': caret_right,
  'caret-square-down': caret_square_down,
  'caret-square-left': caret_square_left,
  'caret-square-right': caret_square_right,
  'caret-square-up': caret_square_up,
  'caret-up': caret_up,
  carrot: carrot,
  'cart-arrow-down': cart_arrow_down,
  'cart-plus': cart_plus,
  'cash-register': cash_register,
  cat: cat,
  certificate: certificate,
  chair: chair,
  chalkboard: chalkboard,
  'chalkboard-teacher': chalkboard_teacher,
  'charging-station': charging_station,
  'chart-area': chart_area,
  'chart-bar': chart_bar,
  'chart-line': chart_line,
  'chart-pie': chart_pie,
  check: check,
  'check-circle': check_circle,
  'check-double': check_double,
  'check-square': check_square,
  cheese: cheese,
  chess: chess,
  'chess-bishop': chess_bishop,
  'chess-board': chess_board,
  'chess-king': chess_king,
  'chess-knight': chess_knight,
  'chess-pawn': chess_pawn,
  'chess-queen': chess_queen,
  'chess-rook': chess_rook,
  'chevron-circle-down': chevron_circle_down,
  'chevron-circle-left': chevron_circle_left,
  'chevron-circle-right': chevron_circle_right,
  'chevron-circle-up': chevron_circle_up,
  'chevron-down': chevron_down,
  'chevron-left': chevron_left,
  'chevron-right': chevron_right,
  'chevron-up': chevron_up,
  child: child,
  church: church,
  circle: circle,
  'circle-notch': circle_notch,
  city: city,
  'clinic-medical': clinic_medical,
  clipboard: clipboard,
  'clipboard-check': clipboard_check,
  'clipboard-list': clipboard_list,
  clock: clock,
  clone: clone,
  'closed-captioning': closed_captioning,
  cloud: cloud,
  'cloud-download-alt': cloud_download_alt,
  'cloud-meatball': cloud_meatball,
  'cloud-moon': cloud_moon,
  'cloud-moon-rain': cloud_moon_rain,
  'cloud-rain': cloud_rain,
  'cloud-showers-heavy': cloud_showers_heavy,
  'cloud-sun': cloud_sun,
  'cloud-sun-rain': cloud_sun_rain,
  'cloud-upload-alt': cloud_upload_alt,
  cocktail: cocktail,
  code: code,
  'code-branch': code_branch,
  coffee: coffee,
  cog: cog,
  cogs: cogs,
  coins: coins,
  columns: columns,
  comment: comment,
  'comment-alt': comment_alt,
  'comment-dollar': comment_dollar,
  'comment-dots': comment_dots,
  'comment-medical': comment_medical,
  'comment-slash': comment_slash,
  comments: comments,
  'comments-dollar': comments_dollar,
  'compact-disc': compact_disc,
  compass: compass,
  compress: compress,
  'compress-arrows-alt': compress_arrows_alt,
  'concierge-bell': concierge_bell,
  cookie: cookie,
  'cookie-bite': cookie_bite,
  copy: copy,
  copyright: copyright,
  couch: couch,
  'credit-card': credit_card,
  crop: crop,
  'crop-alt': crop_alt,
  cross: cross,
  crosshairs: crosshairs,
  crow: crow,
  crown: crown,
  crutch: crutch,
  cube: cube,
  cubes: cubes,
  cut: cut,
  database: database,
  deaf: deaf,
  democrat: democrat,
  desktop: desktop,
  dharmachakra: dharmachakra,
  diagnoses: diagnoses,
  dice: dice,
  'dice-d20': dice_d__20,
  'dice-d6': dice_d__6,
  'dice-five': dice_five,
  'dice-four': dice_four,
  'dice-one': dice_one,
  'dice-six': dice_six,
  'dice-three': dice_three,
  'dice-two': dice_two,
  'digital-tachograph': digital_tachograph,
  directions: directions,
  divide: divide,
  dizzy: dizzy,
  dna: dna,
  dog: dog,
  'dollar-sign': dollar_sign,
  dolly: dolly,
  'dolly-flatbed': dolly_flatbed,
  donate: donate,
  'door-closed': door_closed,
  'door-open': door_open,
  'dot-circle': dot_circle,
  dove: dove,
  download: download,
  'drafting-compass': drafting_compass,
  dragon: dragon,
  'draw-polygon': draw_polygon,
  drum: drum,
  'drum-steelpan': drum_steelpan,
  'drumstick-bite': drumstick_bite,
  dumbbell: dumbbell,
  dumpster: dumpster,
  'dumpster-fire': dumpster_fire,
  dungeon: dungeon,
  edit: edit,
  egg: egg,
  eject: eject,
  'ellipsis-h': ellipsis_h,
  'ellipsis-v': ellipsis_v,
  envelope: envelope,
  'envelope-open': envelope_open,
  'envelope-open-text': envelope_open_text,
  'envelope-square': envelope_square,
  equals: equals,
  eraser: eraser,
  ethernet: ethernet,
  'euro-sign': euro_sign,
  'exchange-alt': exchange_alt,
  exclamation: exclamation,
  'exclamation-circle': exclamation_circle,
  'exclamation-triangle': exclamation_triangle,
  expand: expand,
  'expand-arrows-alt': expand_arrows_alt,
  'external-link-alt': external_link_alt,
  'external-link-square-alt': external_link_square_alt,
  eye: eye,
  'eye-dropper': eye_dropper,
  'eye-slash': eye_slash,
  fan: fan,
  'fast-backward': fast_backward,
  'fast-forward': fast_forward,
  fax: fax,
  feather: feather,
  'feather-alt': feather_alt,
  female: female,
  'fighter-jet': fighter_jet,
  file: file,
  'file-alt': file_alt,
  'file-archive': file_archive,
  'file-audio': file_audio,
  'file-code': file_code,
  'file-contract': file_contract,
  'file-csv': file_csv,
  'file-download': file_download,
  'file-excel': file_excel,
  'file-export': file_export,
  'file-image': file_image,
  'file-import': file_import,
  'file-invoice': file_invoice,
  'file-invoice-dollar': file_invoice_dollar,
  'file-medical': file_medical,
  'file-medical-alt': file_medical_alt,
  'file-pdf': file_pdf,
  'file-powerpoint': file_powerpoint,
  'file-prescription': file_prescription,
  'file-signature': file_signature,
  'file-upload': file_upload,
  'file-video': file_video,
  'file-word': file_word,
  fill: fill,
  'fill-drip': fill_drip,
  film: film,
  filter: filter,
  fingerprint: fingerprint,
  fire: fire,
  'fire-alt': fire_alt,
  'fire-extinguisher': fire_extinguisher,
  'first-aid': first_aid,
  fish: fish,
  'fist-raised': fist_raised,
  flag: flag,
  'flag-checkered': flag_checkered,
  'flag-usa': flag_usa,
  flask: flask,
  flushed: flushed,
  folder: folder,
  'folder-minus': folder_minus,
  'folder-open': folder_open,
  'folder-plus': folder_plus,
  font: font,
  'football-ball': football_ball,
  forward: forward,
  frog: frog,
  frown: frown,
  'frown-open': frown_open,
  'funnel-dollar': funnel_dollar,
  futbol: futbol,
  gamepad: gamepad,
  'gas-pump': gas_pump,
  gavel: gavel,
  gem: gem,
  genderless: genderless,
  ghost: ghost,
  gift: gift,
  gifts: gifts,
  'glass-cheers': glass_cheers,
  'glass-martini': glass_martini,
  'glass-martini-alt': glass_martini_alt,
  'glass-whiskey': glass_whiskey,
  glasses: glasses,
  globe: globe,
  'globe-africa': globe_africa,
  'globe-americas': globe_americas,
  'globe-asia': globe_asia,
  'globe-europe': globe_europe,
  'golf-ball': golf_ball,
  gopuram: gopuram,
  'graduation-cap': graduation_cap,
  'greater-than': greater_than,
  'greater-than-equal': greater_than_equal,
  grimace: grimace,
  grin: grin,
  'grin-alt': grin_alt,
  'grin-beam': grin_beam,
  'grin-beam-sweat': grin_beam_sweat,
  'grin-hearts': grin_hearts,
  'grin-squint': grin_squint,
  'grin-squint-tears': grin_squint_tears,
  'grin-stars': grin_stars,
  'grin-tears': grin_tears,
  'grin-tongue': grin_tongue,
  'grin-tongue-squint': grin_tongue_squint,
  'grin-tongue-wink': grin_tongue_wink,
  'grin-wink': grin_wink,
  'grip-horizontal': grip_horizontal,
  'grip-lines': grip_lines,
  'grip-lines-vertical': grip_lines_vertical,
  'grip-vertical': grip_vertical,
  guitar: guitar,
  'h-square': h_square,
  hamburger: hamburger,
  hammer: hammer,
  hamsa: hamsa,
  'hand-holding': hand_holding,
  'hand-holding-heart': hand_holding_heart,
  'hand-holding-usd': hand_holding_usd,
  'hand-lizard': hand_lizard,
  'hand-middle-finger': hand_middle_finger,
  'hand-paper': hand_paper,
  'hand-peace': hand_peace,
  'hand-point-down': hand_point_down,
  'hand-point-left': hand_point_left,
  'hand-point-right': hand_point_right,
  'hand-point-up': hand_point_up,
  'hand-pointer': hand_pointer,
  'hand-rock': hand_rock,
  'hand-scissors': hand_scissors,
  'hand-spock': hand_spock,
  hands: hands,
  'hands-helping': hands_helping,
  handshake: handshake,
  hanukiah: hanukiah,
  'hard-hat': hard_hat,
  hashtag: hashtag,
  'hat-wizard': hat_wizard,
  haykal: haykal,
  hdd: hdd,
  heading: heading,
  headphones: headphones,
  'headphones-alt': headphones_alt,
  headset: headset,
  heart: heart,
  'heart-broken': heart_broken,
  heartbeat: heartbeat,
  helicopter: helicopter,
  highlighter: highlighter,
  hiking: hiking,
  hippo: hippo,
  history: history,
  'hockey-puck': hockey_puck,
  'holly-berry': holly_berry,
  home: home,
  horse: horse,
  'horse-head': horse_head,
  hospital: hospital,
  'hospital-alt': hospital_alt,
  'hospital-symbol': hospital_symbol,
  'hot-tub': hot_tub,
  hotdog: hotdog,
  hotel: hotel,
  hourglass: hourglass,
  'hourglass-end': hourglass_end,
  'hourglass-half': hourglass_half,
  'hourglass-start': hourglass_start,
  'house-damage': house_damage,
  hryvnia: hryvnia,
  'i-cursor': i_cursor,
  'ice-cream': ice_cream,
  icicles: icicles,
  icons: icons,
  'id-badge': id_badge,
  'id-card': id_card,
  'id-card-alt': id_card_alt,
  igloo: igloo,
  image: image,
  images: images,
  inbox: inbox,
  indent: indent,
  industry: industry,
  infinity: infinity,
  info: info,
  'info-circle': info_circle,
  italic: italic,
  jedi: jedi,
  joint: joint,
  'journal-whills': journal_whills,
  kaaba: kaaba,
  key: key,
  keyboard: keyboard,
  khanda: khanda,
  kiss: kiss,
  'kiss-beam': kiss_beam,
  'kiss-wink-heart': kiss_wink_heart,
  'kiwi-bird': kiwi_bird,
  landmark: landmark,
  language: language,
  laptop: laptop,
  'laptop-code': laptop_code,
  'laptop-medical': laptop_medical,
  laugh: laugh,
  'laugh-beam': laugh_beam,
  'laugh-squint': laugh_squint,
  'laugh-wink': laugh_wink,
  'layer-group': layer_group,
  leaf: leaf,
  lemon: lemon,
  'less-than': less_than,
  'less-than-equal': less_than_equal,
  'level-down-alt': level_down_alt,
  'level-up-alt': level_up_alt,
  'life-ring': life_ring,
  lightbulb: lightbulb,
  link: link,
  'lira-sign': lira_sign,
  list: list,
  'list-alt': list_alt,
  'list-ol': list_ol,
  'list-ul': list_ul,
  'location-arrow': location_arrow,
  lock: lock,
  'lock-open': lock_open,
  'long-arrow-alt-down': long_arrow_alt_down,
  'long-arrow-alt-left': long_arrow_alt_left,
  'long-arrow-alt-right': long_arrow_alt_right,
  'long-arrow-alt-up': long_arrow_alt_up,
  'low-vision': low_vision,
  'luggage-cart': luggage_cart,
  magic: magic,
  magnet: magnet,
  'mail-bulk': mail_bulk,
  male: male,
  map: map,
  'map-marked': map_marked,
  'map-marked-alt': map_marked_alt,
  'map-marker': map_marker,
  'map-marker-alt': map_marker_alt,
  'map-pin': map_pin,
  'map-signs': map_signs,
  marker: marker,
  mars: mars,
  'mars-double': mars_double,
  'mars-stroke': mars_stroke,
  'mars-stroke-h': mars_stroke_h,
  'mars-stroke-v': mars_stroke_v,
  mask: mask,
  medal: medal,
  medkit: medkit,
  meh: meh,
  'meh-blank': meh_blank,
  'meh-rolling-eyes': meh_rolling_eyes,
  memory: memory,
  menorah: menorah,
  mercury: mercury,
  meteor: meteor,
  microchip: microchip,
  microphone: microphone,
  'microphone-alt': microphone_alt,
  'microphone-alt-slash': microphone_alt_slash,
  'microphone-slash': microphone_slash,
  microscope: microscope,
  minus: minus,
  'minus-circle': minus_circle,
  'minus-square': minus_square,
  mitten: mitten,
  mobile: mobile,
  'mobile-alt': mobile_alt,
  'money-bill': money_bill,
  'money-bill-alt': money_bill_alt,
  'money-bill-wave': money_bill_wave,
  'money-bill-wave-alt': money_bill_wave_alt,
  'money-check': money_check,
  'money-check-alt': money_check_alt,
  monument: monument,
  moon: moon,
  'mortar-pestle': mortar_pestle,
  mosque: mosque,
  motorcycle: motorcycle,
  mountain: mountain,
  'mouse-pointer': mouse_pointer,
  'mug-hot': mug_hot,
  music: music,
  'network-wired': network_wired,
  neuter: neuter,
  newspaper: newspaper,
  'not-equal': not_equal,
  'notes-medical': notes_medical,
  'object-group': object_group,
  'object-ungroup': object_ungroup,
  'oil-can': oil_can,
  om: om,
  otter: otter,
  outdent: outdent,
  pager: pager,
  'paint-brush': paint_brush,
  'paint-roller': paint_roller,
  palette: palette,
  pallet: pallet,
  'paper-plane': paper_plane,
  paperclip: paperclip,
  'parachute-box': parachute_box,
  paragraph: paragraph,
  parking: parking,
  passport: passport,
  pastafarianism: pastafarianism,
  paste: paste,
  pause: pause,
  'pause-circle': pause_circle,
  paw: paw,
  peace: peace,
  pen: pen,
  'pen-alt': pen_alt,
  'pen-fancy': pen_fancy,
  'pen-nib': pen_nib,
  'pen-square': pen_square,
  'pencil-alt': pencil_alt,
  'pencil-ruler': pencil_ruler,
  'people-carry': people_carry,
  'pepper-hot': pepper_hot,
  percent: percent,
  percentage: percentage,
  'person-booth': person_booth,
  phone: phone,
  'phone-alt': phone_alt,
  'phone-slash': phone_slash,
  'phone-square': phone_square,
  'phone-square-alt': phone_square_alt,
  'phone-volume': phone_volume,
  'photo-video': photo_video,
  'piggy-bank': piggy_bank,
  pills: pills,
  'pizza-slice': pizza_slice,
  'place-of-worship': place_of_worship,
  plane: plane,
  'plane-arrival': plane_arrival,
  'plane-departure': plane_departure,
  play: play,
  'play-circle': play_circle,
  plug: plug,
  plus: plus,
  'plus-circle': plus_circle,
  'plus-square': plus_square,
  podcast: podcast,
  poll: poll,
  'poll-h': poll_h,
  poo: poo,
  'poo-storm': poo_storm,
  poop: poop,
  portrait: portrait,
  'pound-sign': pound_sign,
  'power-off': power_off,
  pray: pray,
  'praying-hands': praying_hands,
  prescription: prescription,
  'prescription-bottle': prescription_bottle,
  'prescription-bottle-alt': prescription_bottle_alt,
  print: print,
  procedures: procedures,
  'project-diagram': project_diagram,
  'puzzle-piece': puzzle_piece,
  qrcode: qrcode,
  question: question,
  'question-circle': question_circle,
  quidditch: quidditch,
  'quote-left': quote_left,
  'quote-right': quote_right,
  quran: quran,
  radiation: radiation,
  'radiation-alt': radiation_alt,
  rainbow: rainbow,
  random: random,
  receipt: receipt,
  recycle: recycle,
  redo: redo,
  'redo-alt': redo_alt,
  registered: registered,
  'remove-format': remove_format,
  reply: reply,
  'reply-all': reply_all,
  republican: republican,
  restroom: restroom,
  retweet: retweet,
  ribbon: ribbon,
  ring: ring,
  road: road,
  robot: robot,
  rocket: rocket,
  route: route,
  rss: rss,
  'rss-square': rss_square,
  'ruble-sign': ruble_sign,
  ruler: ruler,
  'ruler-combined': ruler_combined,
  'ruler-horizontal': ruler_horizontal,
  'ruler-vertical': ruler_vertical,
  running: running,
  'rupee-sign': rupee_sign,
  'sad-cry': sad_cry,
  'sad-tear': sad_tear,
  satellite: satellite,
  'satellite-dish': satellite_dish,
  save: save,
  school: school,
  screwdriver: screwdriver,
  scroll: scroll,
  'sd-card': sd_card,
  search: search,
  'search-dollar': search_dollar,
  'search-location': search_location,
  'search-minus': search_minus,
  'search-plus': search_plus,
  seedling: seedling,
  server: server,
  shapes: shapes,
  share: share,
  'share-alt': share_alt,
  'share-alt-square': share_alt_square,
  'share-square': share_square,
  'shekel-sign': shekel_sign,
  'shield-alt': shield_alt,
  ship: ship,
  'shipping-fast': shipping_fast,
  'shoe-prints': shoe_prints,
  'shopping-bag': shopping_bag,
  'shopping-basket': shopping_basket,
  'shopping-cart': shopping_cart,
  shower: shower,
  'shuttle-van': shuttle_van,
  sign: sign,
  'sign-in-alt': sign_in_alt,
  'sign-language': sign_language,
  'sign-out-alt': sign_out_alt,
  signal: signal,
  signature: signature,
  'sim-card': sim_card,
  sitemap: sitemap,
  skating: skating,
  skiing: skiing,
  'skiing-nordic': skiing_nordic,
  skull: skull,
  'skull-crossbones': skull_crossbones,
  slash: slash,
  sleigh: sleigh,
  'sliders-h': sliders_h,
  smile: smile,
  'smile-beam': smile_beam,
  'smile-wink': smile_wink,
  smog: smog,
  smoking: smoking,
  'smoking-ban': smoking_ban,
  sms: sms,
  snowboarding: snowboarding,
  snowflake: snowflake,
  snowman: snowman,
  snowplow: snowplow,
  socks: socks,
  'solar-panel': solar_panel,
  sort: sort,
  'sort-alpha-down': sort_alpha_down,
  'sort-alpha-down-alt': sort_alpha_down_alt,
  'sort-alpha-up': sort_alpha_up,
  'sort-alpha-up-alt': sort_alpha_up_alt,
  'sort-amount-down': sort_amount_down,
  'sort-amount-down-alt': sort_amount_down_alt,
  'sort-amount-up': sort_amount_up,
  'sort-amount-up-alt': sort_amount_up_alt,
  'sort-down': sort_down,
  'sort-numeric-down': sort_numeric_down,
  'sort-numeric-down-alt': sort_numeric_down_alt,
  'sort-numeric-up': sort_numeric_up,
  'sort-numeric-up-alt': sort_numeric_up_alt,
  'sort-up': sort_up,
  spa: spa,
  'space-shuttle': space_shuttle,
  'spell-check': spell_check,
  spider: spider,
  spinner: spinner,
  splotch: splotch,
  'spray-can': spray_can,
  square: square,
  'square-full': square_full,
  'square-root-alt': square_root_alt,
  stamp: stamp,
  star: star,
  'star-and-crescent': star_and_crescent,
  'star-half': star_half,
  'star-half-alt': star_half_alt,
  'star-of-david': star_of_david,
  'star-of-life': star_of_life,
  'step-backward': step_backward,
  'step-forward': step_forward,
  stethoscope: stethoscope,
  'sticky-note': sticky_note,
  stop: stop,
  'stop-circle': stop_circle,
  stopwatch: stopwatch,
  store: store,
  'store-alt': store_alt,
  stream: stream,
  'street-view': street_view,
  strikethrough: strikethrough,
  stroopwafel: stroopwafel,
  subscript: subscript,
  subway: subway,
  suitcase: suitcase,
  'suitcase-rolling': suitcase_rolling,
  sun: sun,
  superscript: superscript,
  surprise: surprise,
  swatchbook: swatchbook,
  swimmer: swimmer,
  'swimming-pool': swimming_pool,
  synagogue: synagogue,
  sync: sync,
  'sync-alt': sync_alt,
  syringe: syringe,
  table: table,
  'table-tennis': table_tennis,
  tablet: tablet,
  'tablet-alt': tablet_alt,
  tablets: tablets,
  'tachometer-alt': tachometer_alt,
  tag: tag,
  tags: tags,
  tape: tape,
  tasks: tasks,
  taxi: taxi,
  teeth: teeth,
  'teeth-open': teeth_open,
  'temperature-high': temperature_high,
  'temperature-low': temperature_low,
  tenge: tenge,
  terminal: terminal,
  'text-height': text_height,
  'text-width': text_width,
  th: th,
  'th-large': th_large,
  'th-list': th_list,
  'theater-masks': theater_masks,
  thermometer: thermometer,
  'thermometer-empty': thermometer_empty,
  'thermometer-full': thermometer_full,
  'thermometer-half': thermometer_half,
  'thermometer-quarter': thermometer_quarter,
  'thermometer-three-quarters': thermometer_three_quarters,
  'thumbs-down': thumbs_down,
  'thumbs-up': thumbs_up,
  thumbtack: thumbtack,
  'ticket-alt': ticket_alt,
  times: times,
  'times-circle': times_circle,
  tint: tint,
  'tint-slash': tint_slash,
  tired: tired,
  'toggle-off': toggle_off,
  'toggle-on': toggle_on,
  toilet: toilet,
  'toilet-paper': toilet_paper,
  toolbox: toolbox,
  tools: tools,
  tooth: tooth,
  torah: torah,
  'torii-gate': torii_gate,
  tractor: tractor,
  trademark: trademark,
  'traffic-light': traffic_light,
  train: train,
  tram: tram,
  transgender: transgender,
  'transgender-alt': transgender_alt,
  trash: trash,
  'trash-alt': trash_alt,
  'trash-restore': trash_restore,
  'trash-restore-alt': trash_restore_alt,
  tree: tree,
  trophy: trophy,
  truck: truck,
  'truck-loading': truck_loading,
  'truck-monster': truck_monster,
  'truck-moving': truck_moving,
  'truck-pickup': truck_pickup,
  tshirt: tshirt,
  tty: tty,
  tv: tv,
  umbrella: umbrella,
  'umbrella-beach': umbrella_beach,
  underline: underline,
  undo: undo,
  'undo-alt': undo_alt,
  'universal-access': universal_access,
  university: university,
  unlink: unlink,
  unlock: unlock,
  'unlock-alt': unlock_alt,
  upload: upload,
  user: user,
  'user-alt': user_alt,
  'user-alt-slash': user_alt_slash,
  'user-astronaut': user_astronaut,
  'user-check': user_check,
  'user-circle': user_circle,
  'user-clock': user_clock,
  'user-cog': user_cog,
  'user-edit': user_edit,
  'user-friends': user_friends,
  'user-graduate': user_graduate,
  'user-injured': user_injured,
  'user-lock': user_lock,
  'user-md': user_md,
  'user-minus': user_minus,
  'user-ninja': user_ninja,
  'user-nurse': user_nurse,
  'user-plus': user_plus,
  'user-secret': user_secret,
  'user-shield': user_shield,
  'user-slash': user_slash,
  'user-tag': user_tag,
  'user-tie': user_tie,
  'user-times': user_times,
  users: users,
  'users-cog': users_cog,
  'utensil-spoon': utensil_spoon,
  utensils: utensils,
  'vector-square': vector_square,
  venus: venus,
  'venus-double': venus_double,
  'venus-mars': venus_mars,
  vial: vial,
  vials: vials,
  video: video,
  'video-slash': video_slash,
  vihara: vihara,
  voicemail: voicemail,
  'volleyball-ball': volleyball_ball,
  'volume-down': volume_down,
  'volume-mute': volume_mute,
  'volume-off': volume_off,
  'volume-up': volume_up,
  'vote-yea': vote_yea,
  'vr-cardboard': vr_cardboard,
  walking: walking,
  wallet: wallet,
  warehouse: warehouse,
  water: water,
  'wave-square': wave_square,
  weight: weight,
  'weight-hanging': weight_hanging,
  wheelchair: wheelchair,
  wifi: wifi,
  wind: wind,
  'window-close': window_close,
  'window-maximize': window_maximize,
  'window-minimize': window_minimize,
  'window-restore': window_restore,
  'wine-bottle': wine_bottle,
  'wine-glass': wine_glass,
  'wine-glass-alt': wine_glass_alt,
  'won-sign': won_sign,
  wrench: wrench,
  'x-ray': x_ray,
  'yen-sign': yen_sign,
  'yin-yang': yin_yang,

};
